// extracted by mini-css-extract-plugin
module.exports = {"root":"kJAf3qzzhHWiuWirPULJ","headerWithSuffix":"lq656FnMKQFBb5IUMdD7"};